import $ from 'jquery';
import autosize from 'autosize';

/**
 * Responsive Embeds
 * @url https://foundation.zurb.com/sites/docs/responsive-embed.html
 */
$('iframe[src*="youtube"]').wrap("<div class='responsive-embed widescreen'/>");
$('iframe[src*="vimeo"]').wrap("<div class='responsive-embed widescreen vimeo'/>");
$('iframe[src*="dailymotion"]').wrap("<div class='responsive-embed widescreen dailymotion'/>");


/**
* Autosize Textarea
* @url https://www.jacklmoore.com/autosize/
*/
const textareas = document.querySelectorAll('textarea.js-autosize');
autosize(textareas);
